import type { FilterableByModule } from '@/src/hooks/location-module/location-module.types'
import { LocationModule } from '@/src/hooks/location-module/location-module.types'

export const NOTIFICATION_CATEGORIES = {
  INSIGHTS: 'Auffälligkeiten',
  MEASURES: 'Maßnahmen',
  INVOICES: 'Rechnungsprüfung',
} as const

export type NotificationCategory = (typeof NOTIFICATION_CATEGORIES)[keyof typeof NOTIFICATION_CATEGORIES]

export type NotificationTab = FilterableByModule & {
  labelKey: string
  value: NotificationCategory[]
}

export const NOTIFICATION_TABS: NotificationTab[] = [
  { labelKey: 'notifications.tabs.insights', value: [NOTIFICATION_CATEGORIES.INSIGHTS], module: LocationModule.INSIGHT_INBOX },
  { labelKey: 'notifications.tabs.measures', value: [NOTIFICATION_CATEGORIES.MEASURES], module: LocationModule.MEASURES },
  { labelKey: 'notifications.tabs.invoices', value: [NOTIFICATION_CATEGORIES.INVOICES], module: LocationModule.INVOICE_CHECKING },
]

export const NOTIFICATION_INBOX_APPEARANCE = {
  variables: {
    colorBackground: 'var(--color-white)',
    colorForeground: 'var(--color-black)',
    colorPrimary: 'var(--color-blue-500)',
    colorPrimaryForeground: 'var(--color-white)',
    colorSecondary: 'var(--color-gray-600)',
    colorSecondaryForeground: 'var(--color-gray-700)',
    colorCounter: 'var(--color-blue-500)',
    colorCounterForeground: 'var(--color-white)',
    colorNeutral: 'var(--color-gray-200)',
    colorShadow: 'var(--color-gray-300)',
    fontSize: '14px',
  },
  elements: {
    notificationsTabsTriggerLabel: {
      fontSize: '14px',
      fontWeight: '500',
    },
    inboxStatus__title: {
      fontSize: '14px',
    },
    dropdownItemLabelContainer: {
      fontSize: '14px',
    },
    bellIcon: {
      color: 'var(--color-gray-700)',
    },
    notificationSubject: {
      color: 'var(--color-foreground, #000)',
      fontSize: '14px',
      fontWeight: '116',
    },
    notificationBody: {
      marginTop: '4px',
      color: 'var(--color-secondary-foreground, #4D4D4D)',
      fontSize: '14px',
      fontWeight: '86',
      lineHeight: 'var(--chakra-lineHeights-base)',
    },
    notificationPrimaryAction__button: {
      background: 'var(--color-primary, #1A2FEE)',
      border: '1px solid var(--color-accent-primary, #0A135F)',
      color: 'var(--color-primary-foreground)',
      fontSize: '14px',
      fontWeight: '86',
      borderRadius: '8px',
      padding: '6px 12px',
    },
    notificationSecondaryAction__button: {
      background: 'var(--color-background, #FFF)',
      color: 'var(--color-foreground, #000)',
      fontSize: '14px',
      fontWeight: '86',
      borderRadius: '8px',
      padding: '6px 12px',
    },
  },
}

export const NOTIFICATION_INBOX_LOCALIZATION_DE = {
  locale: 'de-DE',
  'inbox.title': 'Benachrichtigungen',
  'inbox.status.archived': 'Archiviert',
  'inbox.status.unread': 'Ungelesen',
  'inbox.status.unreadRead': 'Ungelesen & Gelesen',
  'inbox.status.options.archived': 'Archiviert',
  'inbox.status.options.unread': 'Ungelesen',
  'inbox.status.options.unreadRead': 'Ungelesen & Gelesen',
  'inbox.filters.dropdownOptions.unread': 'Ungelesen',
  'inbox.filters.dropdownOptions.default': 'Alle',
  'inbox.filters.dropdownOptions.archived': 'Archiviert',
  'notifications.emptyNotice': 'Keine Benachrichtigungen',
  'notifications.actions.readAll': 'Alle als gelesen markieren',
  'notifications.actions.archiveAll': 'Alle archivieren',
  'notifications.newNotifications': 'Neue Benachrichtigungen',
  'preferences.title': 'Einstellungen',
  'preferences.global': 'Globale Einstellungen',
  'preferences.schedule.title': 'Zeitplan',
  'preferences.schedule.headerInfo':
    'Setze deinen Zeitplan. Benachrichtigungen zu externen Kanälen werden außerhalb des Zeitplans pausiert. In-App und kritische Benachrichtigungen werden immer geliefert.',
  'preferences.schedule.description': 'Benachrichtigungen erlauben zwischen:',
  'preferences.schedule.days': 'Tage',
  'preferences.schedule.from': 'Von',
  'preferences.schedule.to': 'Bis',
  'preferences.schedule.sunday': 'Sonntag',
  'preferences.schedule.monday': 'Montag',
  'preferences.schedule.tuesday': 'Dienstag',
  'preferences.schedule.wednesday': 'Mittwoch',
  'preferences.schedule.thursday': 'Donnerstag',
  'preferences.schedule.friday': 'Freitag',
  'preferences.schedule.saturday': 'Samstag',
  'preferences.schedule.info': 'Kritische und In-App-Benachrichtigungen erreichen dich auch außerhalb deines Zeitplans.',
}

export const NOTIFICATION_INBOX_LOCALIZATION_EN = {
  locale: 'en-US',
}
